module.exports = __webpack_public_path__ + "static/media/egg_zhutu_gongkai.24513fd1.png";